import { render, staticRenderFns } from "./powerLoss.vue?vue&type=template&id=f1983ae6&scoped=true&"
import script from "./powerLoss.vue?vue&type=script&lang=js&"
export * from "./powerLoss.vue?vue&type=script&lang=js&"
import style0 from "./powerLoss.vue?vue&type=style&index=0&id=f1983ae6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1983ae6",
  null
  
)

export default component.exports